import { render, staticRenderFns } from "./workStationPage.vue?vue&type=template&id=50c9a952&scoped=true&"
import script from "./workStationPage.vue?vue&type=script&lang=js&"
export * from "./workStationPage.vue?vue&type=script&lang=js&"
import style0 from "./workStationPage.vue?vue&type=style&index=0&id=50c9a952&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c9a952",
  null
  
)

export default component.exports